export default "__VITE_ASSET__6xDMVRYz__"